import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermission } from '../hooks/usePermission';
import { resolveLandingRoute } from '../config/navigation';
import { buildMenuAccessChecker } from '../utils/permissions';

/**
 * `/` → เมนูแรกที่ผู้ใช้คนนี้เปิดได้จริง (KD3 S2459 FLOW-DASH-029)
 *
 * เดิม `<Navigate to="/dashboard">` ตายตัว → role ที่ไม่มี `dashboard.view` (เช่น IT7) เปิด `/`
 * หรือ bookmark หน้าแรกแล้วลงเอยที่ Access Denied ทุกครั้ง ทั้งที่หลัง login / โลโก้ / ปุ่มในหน้า
 * Access Denied ใช้ `resolveLandingRoute` ตัวนี้อยู่แล้ว · ยังไม่ login = ไป /dashboard ให้ guard
 * ส่งต่อไปหน้า login เหมือนเดิม
 */
const RootRedirect: React.FC = () => {
  const { isAuthenticated, isInitializing, permissions } = useAuth();
  const { isSuperAdmin, isSuperUser } = usePermission();
  // ใช้ isInitializing ไม่ใช่ isLoading (เหตุผลเดียวกับ AuthGuard — BUG-AUTH-REMOUNT)
  if (isInitializing) return null;
  if (!isAuthenticated) return <Navigate to="/dashboard" replace />;
  const target = resolveLandingRoute(buildMenuAccessChecker(permissions, isSuperAdmin || isSuperUser));
  return <Navigate to={target} replace />;
};

export default RootRedirect;
